/**
 * Taken from the underscore.string.js library
 * Modified for HealthUnlocked 2014
 */

//  Underscore.string
//  (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
//  Underscore.string is freely distributable under the terms of the MIT license.
//  Documentation: https://github.com/epeli/underscore.string
//  Some code is borrowed from MooTools and Alexandru Marasteanu.
//  Version '2.3.2'
define(['underscore'], function(_) {



  var nativeTrim = String.prototype.trim;
  var nativeTrimRight = String.prototype.trimRight;

  var defaultToWhiteSpace = function(characters) {
    if (characters == null) {
      return '\\s';
    } else if (characters.source) {
      return characters.source;
    } else {
      return '[' + _s.escapeRegExp(characters) + ']';
    }
  };

  var _s = {

    escapeRegExp: function(str) {
      if (str == null) {
        return '';
      }

      return String(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    },

    rtrim: function(str, characters) {
      if (str == null) {
        return '';
      }
      if (!characters && nativeTrimRight) {
        return nativeTrimRight.call(str);
      }
      characters = defaultToWhiteSpace(characters);

      return String(str).replace(new RegExp(characters + '+$'), '');
    },

    prune: function(str, length, pruneStr) {
      if (str == null) {
        return '';
      }

      str = String(str);
      length = ~~length;
      pruneStr = pruneStr != null ? String(pruneStr) : '...';

      if (str.length <= length) {
        return str;
      }

      var tmpl = function(c) {
        return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
      },
        template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'

      if (template.slice(template.length - 2).match(/\w\w/)) {
        template = template.replace(/\s*\S+$/, '');
      } else {
        template = _s.rtrim(template.slice(0, template.length - 1));
      }

      return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
    },

    numberFormat: function(number, dec, dsep, tsep) {
      if (isNaN(number) || number == null) {
        return '';
      }

      number = number.toFixed(~~dec);
      tsep = typeof tsep == 'string' ? tsep : ',';

      var parts = number.split('.'), fnums = parts[0],
        decimals = parts[1] ? (dsep || '.') + parts[1] : '';

      return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
    },

    trim: function(str, characters) {
      str += '';
      if (!characters && nativeTrim) {
        return nativeTrim.call(str);
      }
      characters = defaultToWhiteSpace(characters);
      return str.replace(new RegExp('\^' + characters + '+|' + characters + '+$', 'g'), '');
    },

    slugify: function(str) {
      var from = 'ąàáäâãćęèéëêìíïîłńòóöôõùúüûñçżź',
        to = 'aaaaaaceeeeeiiiilnooooouuuunczz',
        regex = new RegExp(defaultToWhiteSpace(from), 'g');

      str = ('' + str).toLowerCase();

      str = str.replace(regex, function(ch) {
        var index = from.indexOf(ch);
        return to.charAt(index) || '-';
      });

      return _s.trim(str.replace(/[^\w\s-]/g, '').replace(/[-\s]+/g, '-'), '-');
    },


    // This makes the name safe to use for a slug. it is implemantation should be synchronized with
    // https://github.com/HealthUnlocked/Aurora-API/blob/develop/Aurora.API/Utils/Common.cs#L194-L237
    // for SEO sake Ported code from planck

    createSlug: function(str) {

      // ;; Blacklisted characters for slug creation
      // ;; http://www.blooberry.com/indexdot/html/topics/urlencoding.htm

      var SLASHES = /\//g;
      var CONTROL_CHARS = /[\b\t\n\f\r]/g;
      var RESERVED_CHARS = /[\$&\+,\/:;=\?@]/g;
      var UNSAFE_CHARS = /[\"<>#%\{\}\|\^~\[\]`]/g;
      var EXTRA_CHARS = /[\(\)!\-]/g;

      //TODO, find a Javascript equivalent for  org.apache.commons.lang3.StringEscapeUtils/unescapeHtml4

      var unescapeHtml4 = function(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
      };


      if (!str) {
        return '';
      } else {
        return unescapeHtml4(str)
          .toLowerCase()
          .replace(SLASHES, ' ')
          .replace(CONTROL_CHARS, ' ')
          .replace(RESERVED_CHARS, ' ')
          .replace(UNSAFE_CHARS, ' ')
          .replace(EXTRA_CHARS, ' ')
          .trim()
          .replace(/[\s]+/g, '-')
          .replace("'", '');
      }

    },

    escapeTags: function(str) {
      return str ? str.replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br />') + '..........' : '';
    },

    escape: function(str) {
      return str ? str.replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br />') : '';
    },

    removeHU: function(str) {
      // TODO: Remove hack in future when we have correct redirections
      return str ? str.replace(/healthunlocked\.com|http\:\/\/|https\:\/\//g, '') : '';
    },

    escapeQuotes: function(str) {
      return str ? str.replace(/\"/g, '&quot;') : '';
    },

    trimSlashes: function(str) {
      return str.replace(/^\/+|\/+$/g, '');
    },

    stripTags: function(str, stripEndTags) {
      if (str == null) {
        return '';
      }
      str = String(str).replace(/<\/?[^>]+>/g, '');

      return stripEndTags ? str.replace(/<\/?[^>]+$/, '') : str;
    },

    capitalize: function(str) {
      str = str == null ? '' : String(str);
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    humanize: function(str) {
      return _s.capitalize(_s.underscored(str).replace(/_id$/, '').replace(/_/g, ' '));
    },

    underscored: function(str) {
      return _s.trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
    },

    dashed: function(str) {
      return _s.trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1-$2').replace(/[-\s]+/g, '-').toLowerCase();
    },

    truncate: function(str, length, truncateStr) {
      str += '';
      truncateStr = truncateStr || '...';
      length = ~~length;
      return str.length > length ? str.slice(0, length) + truncateStr : str;
    },

    replaceUrlFirstSubdirectory: function(str, newSubdirectory) {
      return str ? str.replace(/(https?:\/\/[^\/]+\/|\/)[^\/]+(.+)/i, '$1' + newSubdirectory + '$2') : '';
    },
  };

  return _s;

});



// WEBPACK FOOTER //
// ./app/assets/js/vendor/underscore/string.js